import { Feather } from '@expo/vector-icons';
import React from 'react';
import { ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';
import Button from '../../components/Button';
import Spacer from '../../components/Spacer';
import { H3, H5, P } from '../../components/Typography';
import Colors from '../../constants/Colors';

const StyledScrollView = styled.ScrollView`
  width: 100%;
  height: 100%;
  padding: 24px;
  background: #fff;
`;

const StyledDarkView = styled.View`
  padding: 24px;
  background: ${Colors.primaryPurple};
  border-radius: 8px;
`;

const ExampleButtonScreen: React.FC = () => {
  return (
    <StyledScrollView>
      <H3 padding={1}>Button Styling</H3>
      <P padding={2}>
        The following are the standard styling for the Button component. Avoid
        deviating from these styles.
      </P>

      <P padding={1}>Normal button without any prop.</P>
      <Button>Normal Button</Button>
      <Spacer size={3} />

      <P padding={1}>Normal button with `color=&apos;secondary&apos;`.</P>
      <Button color='secondary'>Secondary Colored Button</Button>
      <Spacer size={3} />

      <P padding={1}>Button with `outlined` prop.</P>
      <Button outlined>Outlined Button</Button>
      <Spacer size={3} />

      <P padding={1}>Outlined button and secondary color.</P>
      <Button outlined color='secondary'>
        Secondary Outlined Button
      </Button>
      <Spacer size={3} />

      <P padding={1}>Button with `disabled` prop.</P>
      <Button disabled>Disabled Button</Button>
      <Spacer size={3} />

      <P padding={1}>Button with `disabled` and `outlined` prop.</P>
      <Button outlined disabled>
        Disabled Outlined Button
      </Button>
      <Spacer size={3} />

      <P padding={1}>
        Buttons come with 3 standard size flavors (size = &apos;normal&apos; |
        &apos;medium&apos; | &apos;small&apos; | number) and can have custom
        sizes.
      </P>
      <Button size='medium'>Medium Button</Button>
      <Spacer size={2} />
      <Button size='small'>Small Button</Button>
      <Spacer size={3} />

      <StyledDarkView>
        <H5 color='light' padding={1}>
          Dark Backgrounds
        </H5>
        <P padding={1} color='light'>
          On views with dark backgrounds you can use the `inverse` prop.
        </P>
        <Button inverse>Inverse Button</Button>
        <Spacer size={2} />
        <Button inverse outlined>
          Inverse Outlined Button
        </Button>
      </StyledDarkView>

      <Spacer size={3} />

      <H5 padding={1}>Buttons with Icons and Spinners</H5>
      <P padding={1}>
        You can add icons and spinners to buttons using `startIcon` and
        `endIcon` props.
      </P>
      <Button startIcon={<Feather name='check' color='#fff' size={24} />}>
        Start Icon Button
      </Button>
      <Spacer size={2} />
      <Button endIcon={<ActivityIndicator />}>Start Icon Button</Button>
      <Spacer size={2} />
      <Button
        outlined
        endIcon={
          <Feather
            name='chevron-right'
            color={Colors.primaryPurple}
            size={28}
          />
        }
      >
        Start Icon Button
      </Button>
      <Spacer size={2} />

      <Spacer size={10} />
    </StyledScrollView>
  );
};

export default ExampleButtonScreen;
